// extracted by mini-css-extract-plugin
export default {"container":"Reinsurance_container__r9y+N","sectionContent":"Reinsurance_sectionContent__ecZ1M"};